import { connect } from 'react-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { actions, requestProductReviews } from 'src/redux/reviews';
import { selectProductPartner, selectProductReviews } from 'src/redux/selectors';
import { ProductReviews } from '../components/ProductReviews';
import { DispatchProps } from '../types';

const mapStateToProps = (state: ReduxApplicationState) => ({
  reviews: selectProductReviews(state),
  partner: selectProductPartner(state),
});

const mapDispatchToProps: DispatchProps = {
  loadPageOfReviews: (page: number) => requestProductReviews({ query: { page } }),
  onProductReviewsExpandReadMore: actions.onProductReviewsExpandReadMore,
  onProductReviewsNextPage: actions.onProductReviewsNextPage,
  onProductReviewsPagination: actions.onProductReviewsPagination,
  onProductReviewsProductRatingSystem: actions.onProductReviewsProductRatingSystem,
};

export const ProductReviewsContainer = connect(mapStateToProps, mapDispatchToProps)(ProductReviews);
